import {FC, ReactNode} from 'react'

export const FormError: FC<{children: ReactNode}> = ({children}) => {
  return <div className='mt-2 text-danger-400 text-fs-10 error-form'>{children}</div>
}
